import { z } from 'zod'
import { optionalText, requiredText } from '../../../lib/forms/rules'

/**
 * Tatil Günü ekle/düzenle form şeması: tarih ve TR açıklama zorunlu, EN açıklama opsiyonel.
 *
 * <p>Tarih `requiredText()` ile doğrulanır çünkü form değeri ISO dizgidir (`yyyy-MM-dd`) — `FormDateField`
 * Calendar'ın `Date` nesnesini bu biçime çevirir, diğer ekranlardaki tarih alanları da aynı kalıbı kullanır.
 *
 * <p>Açıklama sınırı **1000 karakter VE 1000 bayt** — ikisi aynı sayı değildir ve ikisi de gerekir:
 * kolonlar `VARCHAR2(1000 BYTE)`'tır (`CHAR_USED='B'`, 24.09.2026'da ölçüldü) ve Türkçe harfler UTF-8'de
 * 2 bayt tutar, yani 1000 karakterlik bir metin kolona sığmayabilir. Sunucu da aynı iki kuralı uygular
 * (`@Size` + `@MaxBytes`); buradaki kural kullanıcıya gönderimi beklemeden geri bildirim verir.
 */
export const holidayDayFormSchema = z.object({
  holidayDate: requiredText(),
  descriptionTr: requiredText(1000, 1000),
  descriptionEn: optionalText(1000, 1000),
  halfDay: z.boolean(),
})

export type HolidayDayFormValues = z.infer<typeof holidayDayFormSchema>
